/**
 * 商家后台侧边栏菜单
 * - 默认按 industry 显示
 * - 超管可在「门店管理 → 后台菜单」为每店自定义（shops.appointment_rules.adminMenu.keys）
 * - super_admin 额外显示平台菜单
 */

export const MENU_ITEMS = [
  { path: '/workbench', title: '门店收银', icon: 'el-icon-s-goods', materialIcon: 'point_of_sale', key: 'workbench' },
  { path: '/settings/print', title: '打印设置', icon: 'el-icon-printer', materialIcon: 'print', key: 'printSettings' },
  { path: '/settings/voice', title: '语音播报', icon: 'el-icon-microphone', materialIcon: 'volume_up', key: 'voiceSettings' },
  { path: '/dashboard', title: '数据概览', icon: 'el-icon-data-analysis', materialIcon: 'dashboard', key: 'dashboard' },
  { path: '/knowledge', title: '知识库管理', icon: 'el-icon-document', materialIcon: 'menu_book', key: 'knowledge' },
  { path: '/customers', title: '客户档案', icon: 'el-icon-user', materialIcon: 'groups', key: 'customers' },
  { path: '/session-cards', title: '次卡管理', icon: 'el-icon-ticket', materialIcon: 'confirmation_number', key: 'sessionCards' },
  { path: '/chat', title: '对话记录', icon: 'el-icon-chat-dot-round', materialIcon: 'chat', key: 'chat' },
  { path: '/appointment', title: '预约管理', icon: 'el-icon-date', materialIcon: 'calendar_today', key: 'appointment' },
  { path: '/shop/config', title: '预约与行业', icon: 'el-icon-setting', materialIcon: 'tune', key: 'shopConfig' },
  { path: '/shop/theme', title: '主题与首页', icon: 'el-icon-picture-outline', materialIcon: 'palette', key: 'shopTheme' },
  { path: '/mall', title: '商城管理', icon: 'el-icon-goods', materialIcon: 'inventory_2', key: 'mall' },
  { path: '/lottery', title: '活动抽奖', icon: 'el-icon-trophy', materialIcon: 'celebration', key: 'lottery' },
  { path: '/pet-service-cards', title: '宠物信息卡', icon: 'el-icon-postcard', materialIcon: 'pets', key: 'petServiceCards' },
  { path: '/payments', title: '支付流水', icon: 'el-icon-wallet', materialIcon: 'payments', key: 'payments' },
]

const PLATFORM = [
  { path: '/platform/shops', title: '门店管理', icon: 'el-icon-office-building', materialIcon: 'store', key: 'platformShops' },
  { path: '/platform/admins', title: '账号管理', icon: 'el-icon-user-solid', materialIcon: 'manage_accounts', key: 'platformAdmins' },
]

/** industry 与 shops 表一致 */
export const KEYS_BY_INDUSTRY = {
  barber: ['workbench', 'printSettings', 'voiceSettings', 'appointment', 'customers', 'sessionCards', 'shopConfig', 'shopTheme', 'mall', 'payments', 'knowledge', 'chat', 'dashboard'],
  beauty: ['workbench', 'printSettings', 'voiceSettings', 'appointment', 'customers', 'sessionCards', 'shopConfig', 'shopTheme', 'mall', 'payments', 'knowledge', 'chat', 'dashboard'],
  edu: ['workbench', 'printSettings', 'voiceSettings', 'appointment', 'customers', 'sessionCards', 'shopConfig', 'shopTheme', 'knowledge', 'chat', 'dashboard'],
  restaurant: ['workbench', 'printSettings', 'appointment', 'customers', 'sessionCards', 'shopConfig', 'shopTheme', 'mall', 'payments', 'knowledge', 'chat', 'dashboard'],
  pet: ['workbench', 'printSettings', 'voiceSettings', 'appointment', 'customers', 'sessionCards', 'petServiceCards', 'shopConfig', 'shopTheme', 'mall', 'lottery', 'payments', 'knowledge', 'chat', 'dashboard'],
  other: ['workbench', 'printSettings', 'voiceSettings', 'appointment', 'customers', 'sessionCards', 'petServiceCards', 'shopConfig', 'shopTheme', 'mall', 'lottery', 'payments', 'knowledge', 'chat', 'dashboard'],
}

/** 与服务端 adminMenuService.AUTO_APPEND_IF_INDUSTRY_DEFAULT 对齐 */
const AUTO_APPEND_IF_INDUSTRY_DEFAULT = ['sessionCards']

export function getDefaultMenuKeys(industry) {
  const ind = industry && KEYS_BY_INDUSTRY[industry] ? industry : 'other'
  return [...(KEYS_BY_INDUSTRY[ind] || KEYS_BY_INDUSTRY.other)]
}

function mergeAutoAppendKeys(keys, industry) {
  const defaults = getDefaultMenuKeys(industry)
  const out = Array.isArray(keys) ? [...keys] : []
  for (const k of AUTO_APPEND_IF_INDUSTRY_DEFAULT) {
    if (defaults.includes(k) && !out.includes(k)) {
      const idx = out.indexOf('customers')
      if (idx >= 0) out.splice(idx + 1, 0, k)
      else out.push(k)
    }
  }
  return out
}

export function getSidebarMenu({ industry, isSuper, menuKeys }) {
  const ind = industry && KEYS_BY_INDUSTRY[industry] ? industry : 'other'
  const defaultKeys = KEYS_BY_INDUSTRY[ind] || KEYS_BY_INDUSTRY.other
  const raw = Array.isArray(menuKeys) && menuKeys.length ? menuKeys : defaultKeys
  const keys = mergeAutoAppendKeys(raw, ind)
  const business = MENU_ITEMS.filter((m) => keys.includes(m.key))
  if (isSuper) return [...PLATFORM, ...business]
  return business
}

/** 路由 path → menuKey，用于无权限页重定向 */
const PATH_TO_KEY = MENU_ITEMS.reduce((acc, m) => {
  acc[m.path] = m.key
  return acc
}, {
  '/knowledge/edit': 'knowledge',
})

export function menuKeyForPath(path) {
  if (!path) return null
  if (PATH_TO_KEY[path]) return PATH_TO_KEY[path]
  const base = Object.keys(PATH_TO_KEY).find((p) => path.startsWith(p + '/'))
  return base ? PATH_TO_KEY[base] : null
}

export function firstAllowedPath(menuKeys, isSuper) {
  const menus = getSidebarMenu({
    industry: 'other',
    isSuper,
    menuKeys,
  })
  return menus[0]?.path || '/workbench'
}
